import React from 'react';

type ClickOutsideProps = {
  onClickOutside: (e: TouchEvent | MouseEvent) => void;
  wrapper: 'span' | 'div';
  children:
    | React.ReactNode
    | ((props: { onMouseDown: () => void; onTouchStart: () => void }) => React.ReactNode);
};

export class ClickOutside extends React.Component<ClickOutsideProps> {
  clickCaptured = false;

  render() {
    return this.renderComponent();
  }

  renderComponent() {
    if (typeof this.props.children === 'function') {
      return this.props.children(this.getProps());
    }

    return React.createElement(this.props.wrapper || 'span', this.getProps(), this.props.children);
  }

  getProps() {
    return {
      onMouseDown: this.innerClick,
      onTouchStart: this.innerClick,
    };
  }

  innerClick = () => {
    this.clickCaptured = true;
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.documentClick);
    document.addEventListener('touchstart', this.documentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.documentClick);
    document.removeEventListener('touchstart', this.documentClick);
  }

  documentClick = (event: TouchEvent | MouseEvent) => {
    if (!this.clickCaptured && this.props.onClickOutside) {
      this.props.onClickOutside(event);
    }
    this.clickCaptured = false;
  };
}
